import React from 'react';

const PerformanceView = ({ performance, t, lang }) => {
  if (!performance) return null;

  return (
    <>
      <div className="perf-grid">
        <div className="perf-card">
          <div className="perf-card-title">{t.app.winRate} (All time)</div>
          <div className="perf-card-value positive">{performance.all_time?.win_rate}%</div>
        </div>
        <div className="perf-card">
          <div className="perf-card-title">{t.app.avgReturn}</div>
          <div className="perf-card-value positive">+{performance.all_time?.avg_return}%</div>
        </div>
        <div className="perf-card">
          <div className="perf-card-title">Drawdown max</div>
          <div className="perf-card-value negative">{performance.all_time?.max_drawdown}%</div>
        </div>
        <div className="perf-card">
          <div className="perf-card-title">{t.app.totalRecos}</div>
          <div className="perf-card-value">{performance.all_time?.total_recos}</div>
        </div>
      </div>
      <div className="tabs mb-4">
        <button className="tab active">{t.app.all}</button>
        <button className="tab">📈 {t.app.stocks}</button>
        <button className="tab">₿ {t.app.crypto}</button>
      </div>
      <div className="history-card">
        <div className="history-header">
          <span className="history-title">
            {lang === 'fr' ? 'Performance détaillée' : 'Detailed Performance'}
          </span>
        </div>
        <table className="history-table">
          <thead>
            <tr>
              <th>Période</th>
              <th>Win Rate</th>
              <th>Rendement</th>
              <th>Recos</th>
            </tr>
          </thead>
          <tbody>
            {performance.monthly?.map((m, i) => (
              <tr key={i}>
                <td>{m.period}</td>
                <td>{m.win_rate}%</td>
                <td className="text-success">+{m.return}%</td>
                <td>{m.recos}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PerformanceView;
